export const MULTIPLE_SLASHES = /\/{2}(\/*)/g;
